import { useParams } from "react-router-dom";
import MovieLoading from "../../components/MovieLoading/MovieLoading";
import {
  useCancelReserveShowtime,
  useGetConfectioneries,
  useGetConfectioneriesApi,
  useGetConsecutive,
  useGetShowtimeData,
} from "../../hooks/useCheckoutQueries";
import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useCheckoutStore } from "../../store/useCheckoutStore";
import ShowtimeDetail from "../../components/ShowtimeDetail/ShowtimeDetail";

function Showtime() {
  const { showtime: showtimeId } = useParams();
  const showtimeDataQuery = useGetShowtimeData(showtimeId);
  const consecutiveQuery = useGetConsecutive();
  const confectioneriesApiQuery = useGetConfectioneriesApi();
  const confectioneriesQuery = useGetConfectioneries();
  const { resetCheckout, consecutive } = useCheckoutStore();
  const cancelReserveMutation = useCancelReserveShowtime();

  const queryClient = useQueryClient();

  const handleCancelReservation = () => {
    cancelReserveMutation.mutate(showtimeId, {
      onSuccess: () => {
        queryClient.invalidateQueries(["ShowtimeData"]);
      },
    });
  };

  useEffect(() => {
    return () => {
      queryClient.clear();
      resetCheckout();
      if (consecutive) {
        handleCancelReservation();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isLoading =
    consecutiveQuery.isLoading ||
    confectioneriesApiQuery.isLoading ||
    confectioneriesQuery.isLoading ||
    showtimeDataQuery.isLoading;

  const isSuccess =
    consecutiveQuery.isSuccess &&
    confectioneriesApiQuery.isSuccess &&
    confectioneriesQuery.isSuccess &&
    showtimeDataQuery.isSuccess;

  return isLoading || !isSuccess ? <MovieLoading /> : <ShowtimeDetail />;
}

export default Showtime;
